import Label from '../label';

type InputFieldType = {
  activeField?: string;
  className?: string;
  label?: string;
  name: string;
  value: string;
  onChange: (event: any) => void;
  onKeyDown?: (event: any) => void;
  onBlur?: () => void;
  readOnly?: boolean;
  required?: boolean;
  rows?: number;
  type?: string;
  placeholder?: string;
};

const InputField = ({
  activeField,
  className = '',
  label,
  name,
  type,
  onChange,
  onBlur,
  placeholder,
  readOnly = false,
  required = false,
  rows = 10,
  value = '',
  onKeyDown
}: InputFieldType) => {
  const inputClasses = `block text-base font-open-sans w-full px-3 py-2 border border-neutral-300 rounded-lg placeholder-neutral-600 focus:outline-none focus:border-primary-600`;

  return (
    <div className="relative mt-2">
      <div
        className={`label-wrapper mb-2 ${
          (activeField && 'dirty') || (value && value.length > 0 && 'dirty')
        }`}
      >
        {label && <Label htmlFor={name}>{label}</Label>}
      </div>
      {type === 'textarea' ? (
        <textarea
          id={name}
          value={value}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          rows={rows}
          required={required}
          readOnly={readOnly}
          className={`${inputClasses} ${readOnly && 'cursor-not-allowed'}`}
        >
          {value}
        </textarea>
      ) : (
        <input
          id={name}
          data-testid={name}
          placeholder={placeholder}
          value={value}
          name={name}
          type={type}
          onChange={onChange}
          onBlur={onBlur}
          required={required}
          readOnly={readOnly}
          className={`${inputClasses} ${
            readOnly && 'cursor-not-allowed'
          } ${className}`}
          onKeyDown={onKeyDown}
        />
      )}
    </div>
  );
};

export default InputField;
